export default {"src":"/_next/static/media/en.6e1628b0.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};